import { IVideo } from '@server/collections/common/interfaces/video.interface';
import { Pipe, PipeTransform } from '@angular/core';
import { Cloudinary } from '@cloudinary/url-gen/instance/Cloudinary';
import {crop, scale} from "@cloudinary/url-gen/actions/resize";
import { AspectRatio } from '@cloudinary/url-gen/qualifiers/aspectRatio';
@Pipe({
  name: 'resizeVideoUrl',
  standalone: true
})
export class ResizeVideoUrlPipe implements PipeTransform {

  transform(video: IVideo | string, width: number, fallbackVideo?: string): any {
    if (typeof video === 'string') {
      return video;
    }

    const cld = new Cloudinary({
      cloud: {
        cloudName: 'expometals'
      }
    });
    const cldVideo = cld.video(video.public_id);
    cldVideo.resize(scale().width(width).aspectRatio(AspectRatio.ar16X9()));
    return cldVideo.toURL();
  }

}
